import React,{Component} from "react";
import './App.css';
import RegisterFoxproForm from "./components/registerFoxproForm";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class App extends Component {

    render = () => {
        return (
            <React.Fragment>
                <ToastContainer/>
                <main className="container">
                    <RegisterFoxproForm/>
                </main>
            </React.Fragment>
        );
    }
}

export default App;
